import { render } from "./CuratedMessageCards.vue?vue&type=template&id=3ecc396a"
import script from "./CuratedMessageCards.vue?vue&type=script&lang=js"
export * from "./CuratedMessageCards.vue?vue&type=script&lang=js"

import "./CuratedMessageCards.vue?vue&type=style&index=0&id=3ecc396a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__